import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, User, MessageCircle, Calendar, Settings, Bell, Eye, CheckCircle2, XCircle, Users } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
const GuardianDashboard = () => {
  const today = new Date();
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const currentDay = dayNames[today.getDay()];
  // Mock data for child's profile
  const childProfile = {
    name: 'Mohammed',
    age: 32,
    education: "Master's in Engineering",
    profession: 'Software Engineer'
  };
  // Mock data for current match
  const currentMatch = {
    name: 'Sarah',
    age: 28,
    education: "Master's in Business Administration",
    profession: 'Marketing Executive',
    avatar: 'https://images.unsplash.com/photo-1583391265699-e93a29f2f2c8?q=80&w=2000&auto=format&fit=crop',
    conversationSummary: '15 messages exchanged on Friday',
    guardianName: 'Fatima Ahmed',
    lastActivity: '2 hours ago'
  };
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-238">
      <Header data-id="element-239" />
      <main className="flex-grow py-8 px-4" data-id="element-240">
        <div className="max-w-6xl mx-auto" data-id="element-241">
          {/* Guardian Dashboard Header */}
          <div className="bg-gradient-to-r from-amber-700 to-amber-800 rounded-xl p-6 mb-8 text-white shadow-md" data-id="element-242">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-243">
              <div data-id="element-244">
                <div className="flex items-center mb-2" data-id="element-245">
                  <Shield className="h-6 w-6 mr-2" data-id="element-246" />
                  <h1 className="text-2xl md:text-3xl font-bold" data-id="element-247">
                    Guardian Dashboard
                  </h1>
                </div>
                <p className="text-amber-100" data-id="element-248">
                  Overseeing {childProfile.name}'s marriage journey
                </p>
              </div>
              <div className="mt-4 md:mt-0" data-id="element-249">
                <Link to="/guardian" className="bg-white text-amber-800 hover:bg-amber-100 font-medium py-2 px-4 rounded-lg transition duration-300 flex items-center" data-id="element-250">
                  <Settings className="h-4 w-4 mr-2" data-id="element-251" />
                  Guardian Settings
                </Link>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-252">
            {/* Main Content Area */}
            <div className="lg:col-span-2 space-y-8" data-id="element-253">
              {/* Child's Current Match */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-254">
                <div className="bg-amber-50 p-4 border-b border-amber-100" data-id="element-255">
                  <div className="flex items-center justify-between" data-id="element-256">
                    <h2 className="text-xl font-bold text-amber-900" data-id="element-257">
                      Current Match Overview
                    </h2>
                    <span className="text-sm text-amber-700 font-medium" data-id="element-258">
                      {currentDay === 'Friday' ? 'Active Today' : 'Reflection Period'}
                    </span>
                  </div>
                </div>
                <div className="p-6" data-id="element-259">
                  <div className="flex flex-col md:flex-row" data-id="element-260">
                    <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-261">
                      <div className="aspect-square rounded-lg overflow-hidden bg-gray-100 mb-4" data-id="element-262">
                        <img src="https://images.unsplash.com/photo-1583391265699-e93a29f2f2c8?q=80&w=2000&auto=format&fit=crop" alt="Match profile" className="w-full h-full object-cover" data-id="element-263" />
                      </div>
                      <div className="bg-emerald-50 p-3 rounded-lg" data-id="element-264">
                        <div className="flex items-center text-sm text-emerald-800" data-id="element-265">
                          <Eye className="h-4 w-4 mr-2" data-id="element-266" />
                          <span data-id="element-267">You can view all conversations</span>
                        </div>
                      </div>
                    </div>
                    <div className="md:w-2/3 md:pl-6" data-id="element-268">
                      <div className="flex justify-between items-start mb-4" data-id="element-269">
                        <div data-id="element-270">
                          <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-271">
                            {currentMatch.name}, {currentMatch.age}
                          </h3>
                          <span className="bg-emerald-100 text-emerald-800 text-xs px-2 py-1 rounded-full font-medium" data-id="element-272">
                            Verified Emirati
                          </span>
                        </div>
                      </div>
                      <div className="space-y-3 mb-6" data-id="element-273">
                        <div data-id="element-274">
                          <p className="text-sm font-medium text-gray-500" data-id="element-275">
                            Education
                          </p>
                          <p className="text-gray-800" data-id="element-276">
                            {currentMatch.education}
                          </p>
                        </div>
                        <div data-id="element-277">
                          <p className="text-sm font-medium text-gray-500" data-id="element-278">
                            Profession
                          </p>
                          <p className="text-gray-800" data-id="element-279">
                            {currentMatch.profession}
                          </p>
                        </div>
                        <div data-id="element-280">
                          <p className="text-sm font-medium text-gray-500" data-id="element-281">
                            Conversation Activity
                          </p>
                          <p className="text-gray-800" data-id="element-282">
                            {currentMatch.conversationSummary}
                          </p>
                        </div>
                        <div data-id="element-283">
                          <p className="text-sm font-medium text-gray-500" data-id="element-284">
                            Their Guardian
                          </p>
                          <p className="text-gray-800" data-id="element-285">
                            {currentMatch.guardianName}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-3" data-id="element-286">
                        <button className="flex-1 bg-emerald-700 hover:bg-emerald-800 text-white font-medium py-2 px-4 rounded-lg transition duration-300 flex items-center justify-center" data-id="element-287">
                          <MessageCircle className="h-4 w-4 mr-2" data-id="element-288" />
                          View Conversations
                        </button>
                        <button className="flex-1 bg-amber-600 hover:bg-amber-700 text-white font-medium py-2 px-4 rounded-lg transition duration-300 flex items-center justify-center" data-id="element-289">
                          <Users className="h-4 w-4 mr-2" data-id="element-290" />
                          Chat with Guardian
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Match Decision Panel */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-291">
                <div className="p-6" data-id="element-292">
                  <h2 className="text-xl font-bold text-emerald-900 mb-4" data-id="element-293">
                    Match Decision
                  </h2>
                  <div className="bg-amber-50 p-4 rounded-lg mb-6" data-id="element-294">
                    <p className="text-amber-800 text-sm" data-id="element-295">
                      As {childProfile.name}'s guardian, you can approve or
                      decline this match. Your decision will be communicated to
                      your child and the other party.
                    </p>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-296">
                    <button className="bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center" data-id="element-297">
                      <CheckCircle2 className="h-5 w-5 mr-2" data-id="element-298" />
                      Approve Match
                    </button>
                    <button className="border-2 border-gray-300 hover:bg-gray-100 text-gray-700 font-bold py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center" data-id="element-299">
                      <XCircle className="h-5 w-5 mr-2" data-id="element-300" />
                      Decline Match
                    </button>
                  </div>
                </div>
              </div>
              {/* Conversation Monitor */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-301">
                <div className="p-6" data-id="element-302">
                  <div className="flex items-center justify-between mb-4" data-id="element-303">
                    <h2 className="text-xl font-bold text-emerald-900" data-id="element-304">
                      Friday Conversation
                    </h2>
                    <span className="text-sm text-gray-500" data-id="element-305">
                      Last activity: {currentMatch.lastActivity}
                    </span>
                  </div>
                  <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-306">
                    <div className="bg-gray-50 p-4 max-h-96 overflow-y-auto" data-id="element-307">
                      <div className="space-y-4" data-id="element-308">
                        <div className="flex justify-start" data-id="element-309">
                          <div className="bg-white border border-gray-200 rounded-lg p-3 max-w-xs" data-id="element-310">
                            <p className="text-sm text-gray-800" data-id="element-311">
                              Assalamu alaikum. It's nice to meet you.
                            </p>
                            <p className="text-xs text-gray-500 mt-1" data-id="element-312">
                              {currentMatch.name} • Friday 10:00 AM
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-end" data-id="element-313">
                          <div className="bg-emerald-100 rounded-lg p-3 max-w-xs" data-id="element-314">
                            <p className="text-sm text-emerald-900" data-id="element-315">
                              Walaikum assalam. Thank you for connecting with
                              me.
                            </p>
                            <p className="text-xs text-emerald-700 mt-1" data-id="element-316">
                              {childProfile.name} • Friday 10:05 AM
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-start" data-id="element-317">
                          <div className="bg-white border border-gray-200 rounded-lg p-3 max-w-xs" data-id="element-318">
                            <p className="text-sm text-gray-800" data-id="element-319">
                              I saw in your profile that you work in
                              engineering. What area do you specialize in?
                            </p>
                            <p className="text-xs text-gray-500 mt-1" data-id="element-320">
                              {currentMatch.name} • Friday 10:10 AM
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-end" data-id="element-321">
                          <div className="bg-emerald-100 rounded-lg p-3 max-w-xs" data-id="element-322">
                            <p className="text-sm text-emerald-900" data-id="element-323">
                              I work in software engineering, specifically in
                              developing applications. What about your work in
                              marketing?
                            </p>
                            <p className="text-xs text-emerald-700 mt-1" data-id="element-324">
                              {childProfile.name} • Friday 10:15 AM
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 bg-blue-50 p-4 rounded-lg" data-id="element-325">
                    <div className="flex items-start" data-id="element-326">
                      <Eye className="h-5 w-5 text-blue-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-327" />
                      <p className="text-sm text-blue-800" data-id="element-328">
                        You're viewing this conversation in read-only mode. You
                        can take over the conversation at any time if needed.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Sidebar */}
            <div className="space-y-8" data-id="element-329">
              {/* Child's Profile Summary */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-330">
                <div className="p-6" data-id="element-331">
                  <div className="flex items-center justify-between mb-4" data-id="element-332">
                    <h2 className="text-xl font-bold text-emerald-900" data-id="element-333">
                      {childProfile.name}'s Profile
                    </h2>
                    <Link to="/profile-setup" className="text-emerald-700 hover:text-emerald-800" data-id="element-334">
                      <Settings className="h-5 w-5" data-id="element-335" />
                    </Link>
                  </div>
                  <div className="flex items-center mb-6" data-id="element-336">
                    <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mr-4" data-id="element-337">
                      <User className="h-8 w-8 text-emerald-700" data-id="element-338" />
                    </div>
                    <div data-id="element-339">
                      <h3 className="text-lg font-bold text-gray-900" data-id="element-340">
                        {childProfile.name}, {childProfile.age}
                      </h3>
                      <span className="bg-emerald-100 text-emerald-800 text-xs px-2 py-1 rounded-full font-medium" data-id="element-341">
                        Active Profile
                      </span>
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-342">
                    <div data-id="element-343">
                      <p className="text-sm font-medium text-gray-500" data-id="element-344">
                        Education
                      </p>
                      <p className="text-gray-800" data-id="element-345">{childProfile.education}</p>
                    </div>
                    <div data-id="element-346">
                      <p className="text-sm font-medium text-gray-500" data-id="element-347">
                        Profession
                      </p>
                      <p className="text-gray-800" data-id="element-348">{childProfile.profession}</p>
                    </div>
                    <div data-id="element-349">
                      <p className="text-sm font-medium text-gray-500" data-id="element-350">
                        Guardian Oversight
                      </p>
                      <p className="text-gray-800" data-id="element-351">Full Access</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Quick Actions */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-352">
                <div className="p-6" data-id="element-353">
                  <h2 className="text-xl font-bold text-emerald-900 mb-4" data-id="element-354">
                    Quick Actions
                  </h2>
                  <div className="space-y-3" data-id="element-355">
                    <button className="w-full bg-amber-50 hover:bg-amber-100 text-amber-900 font-medium py-3 px-4 rounded-lg transition duration-300 flex items-center" data-id="element-356">
                      <MessageCircle className="h-5 w-5 mr-3" data-id="element-357" />
                      <span data-id="element-358">Chat with Other Guardian</span>
                    </button>
                    <button className="w-full bg-gray-50 hover:bg-gray-100 text-gray-900 font-medium py-3 px-4 rounded-lg transition duration-300 flex items-center" data-id="element-359">
                      <Eye className="h-5 w-5 mr-3" data-id="element-360" />
                      <span data-id="element-361">View All Conversations</span>
                    </button>
                    <button className="w-full bg-gray-50 hover:bg-gray-100 text-gray-900 font-medium py-3 px-4 rounded-lg transition duration-300 flex items-center" data-id="element-362">
                      <Settings className="h-5 w-5 mr-3" data-id="element-363" />
                      <span data-id="element-364">Adjust Oversight Level</span>
                    </button>
                  </div>
                </div>
              </div>
              {/* Notifications */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-365">
                <div className="p-6" data-id="element-366">
                  <div className="flex items-center justify-between mb-4" data-id="element-367">
                    <h2 className="text-xl font-bold text-emerald-900" data-id="element-368">
                      Guardian Alerts
                    </h2>
                    <span className="bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded-full" data-id="element-369">
                      3 New
                    </span>
                  </div>
                  <div className="space-y-3" data-id="element-370">
                    <div className="p-3 bg-amber-50 rounded-lg" data-id="element-371">
                      <div className="flex items-start" data-id="element-372">
                        <Bell className="h-5 w-5 text-amber-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-373" />
                        <div data-id="element-374">
                          <p className="text-gray-800 font-medium text-sm" data-id="element-375">
                            New match received
                          </p>
                          <p className="text-xs text-gray-600 mt-1" data-id="element-376">
                            Review the match and conversation
                          </p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-377">
                            Friday 9:00 AM
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 bg-blue-50 rounded-lg" data-id="element-378">
                      <div className="flex items-start" data-id="element-379">
                        <MessageCircle className="h-5 w-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-380" />
                        <div data-id="element-381">
                          <p className="text-gray-800 font-medium text-sm" data-id="element-382">
                            Message from other guardian
                          </p>
                          <p className="text-xs text-gray-600 mt-1" data-id="element-383">
                            Fatima Ahmed wants to connect
                          </p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-384">
                            2 hours ago
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 bg-gray-50 rounded-lg" data-id="element-385">
                      <div className="flex items-start" data-id="element-386">
                        <Calendar className="h-5 w-5 text-gray-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-387" />
                        <div data-id="element-388">
                          <p className="text-gray-800 font-medium text-sm" data-id="element-389">
                            Reflection period ends Thursday
                          </p>
                          <p className="text-xs text-gray-600 mt-1" data-id="element-390">
                            Decision needed by end of week
                          </p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-391">
                            Yesterday
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Calendar */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-392">
                <div className="p-6" data-id="element-393">
                  <h2 className="text-xl font-bold text-emerald-900 mb-4" data-id="element-394">
                    This Week
                  </h2>
                  <div className="space-y-3" data-id="element-395">
                    <div className="p-3 bg-emerald-100 rounded-lg" data-id="element-396">
                      <div className="flex items-center" data-id="element-397">
                        <Calendar className="h-5 w-5 text-emerald-700 mr-2" data-id="element-398" />
                        <h3 className="font-medium text-emerald-900" data-id="element-399">
                          Friday - Match Day
                        </h3>
                      </div>
                      <p className="text-sm text-emerald-700 mt-1" data-id="element-400">
                        New match and conversation window
                      </p>
                    </div>
                    <div className="p-3 bg-amber-100 rounded-lg" data-id="element-401">
                      <div className="flex items-center" data-id="element-402">
                        <Calendar className="h-5 w-5 text-amber-700 mr-2" data-id="element-403" />
                        <h3 className="font-medium text-amber-900" data-id="element-404">
                          Saturday - Thursday
                        </h3>
                      </div>
                      <p className="text-sm text-amber-700 mt-1" data-id="element-405">
                        Reflection and decision period
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-406" />
    </div>;
};
export default GuardianDashboard;